import React, {
  createContext,
  useMemo,
  useState,
} from 'react';
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import dayjs from 'dayjs';
import { COOKIES } from '@/lib/constants';
import { LoginToken } from '@/types/token';

export interface AuthService {
  isAuth(): boolean;

  setToken(token: string): void;

  removeToken(): void;
}

export const AuthContext = createContext<AuthService>({
  isAuth(): boolean {
    return false;
  },
  removeToken(): void {
  },
  setToken(): void {
  },

});

export default function AuthProvider({ children }: React.PropsWithChildren) {
  const [, setAuthTokenToken] = useState(Cookies.get(COOKIES.ACCESS_TOKEN));

  const isAuth = () => {
    const token = Cookies.get(COOKIES.ACCESS_TOKEN);

    if (token) {
      const data = jwtDecode<LoginToken>(token);

      return data !== null && data.exp > Date.now() / 1000;
    }

    return false;
  };

  const setToken = (jwtToken: string) => {
    setAuthTokenToken(jwtToken);

    Cookies.set(
      COOKIES.ACCESS_TOKEN,
      jwtToken,
      {
        secure: true,
        sameSite: 'lax',
        expires: dayjs().add(1, 'day').toDate(),
      },
    );
  };

  const removeToken = () => {
    Cookies.remove(COOKIES.ACCESS_TOKEN);

    setAuthTokenToken(Cookies.get(COOKIES.ACCESS_TOKEN));
  };

  const authService = useMemo(() => ({
    isAuth,
    setToken,
    removeToken,
  }), [Cookies.get(COOKIES.ACCESS_TOKEN)]);

  return (
    <AuthContext.Provider value={authService}>
      {children}
    </AuthContext.Provider>
  );
}
